import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class BacklogInitiativesInitiativeOverviewRoute extends Route {
  async beforeModel() {
    const initiative = this.modelFor('backlog.initiatives.initiative');
    await initiative.reload();
  }
  model() {
    const initiative = this.modelFor('backlog.initiatives.initiative');
    return initiative;
  }
}

export default instrumentRoutePerformance(
  BacklogInitiativesInitiativeOverviewRoute,
);
